import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const FullHeightWrapper = styled(Grid)`
  height: calc(100vh - 60px);
`;
